import BillingPage from './BillingPage';
import './assets/billing.scss'

export default BillingPage;